import * as React from "react";
import { Input, InputGroup, InputGroupText, Label } from "reactstrap";
import "../assets/style/SearchBox.css";

interface ISearchBoxProps {
  placeHolder: string;
  label?: string;
  icon?: React.ReactElement;
  value?: string | number;
  onChange?: (e: any) => void;
  numberOnly?: boolean;
  maxLength?: number;
  validateFlag?: boolean;
}

const SearchBox: React.FunctionComponent<ISearchBoxProps> = (props) => {
  return (
    <div className="mb-3">
      {props.label && (
        <Label className="mb-1 text-start search-label">{props.label}</Label>
      )}
      <InputGroup className="input-group-parent">
        <Input
          type={props.numberOnly ? "number" : "text"}
          value={props.value}
          onChange={props.onChange}
          placeholder={props.placeHolder}
          maxLength={props.maxLength}
          className="border-end-0 input-control form-control-search-box"
          autoComplete="off"
        />
        <InputGroupText>{props.icon}</InputGroupText>
      </InputGroup>

      {props.validateFlag &&
        <p className="error-msg">*Invalid input</p>
      }
    </div>
  );
};

export default SearchBox;
